import React, { useEffect, useState } from 'react';
import { useMsal } from "@azure/msal-react";
import { useNavigate } from 'react-router-dom';

export default function Home() {
  const { accounts } = useMsal();
  const account = accounts[0];
  const navigate = useNavigate();
 
  const ADMIN_GROUP_ID = "3d2095c9-f9c2-4484-8ac2-68f6760703cb";
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const groups = account?.idTokenClaims?.groups || [];
    setIsAdmin(groups.includes(ADMIN_GROUP_ID));
  }, [account]);

  return (
    <div style={{ textAlign: 'center', padding: '5vw' }}>
      <h1 style={{ fontSize: '2.5rem', color: '#1a202c', marginBottom: '2rem' }}>
        Extract from the FMCSA and Chassis Images
      </h1>
      <button
        // onClick={() => navigate('/upload-fmcsa')}  //Version 1
        onClick={() => navigate('/upload')}  //Version 2
        style={{
          padding: '10px 20px',
          fontSize: '1.2rem',
          backgroundColor: '#4CAF50',
          color: 'white',
          border: 'none',
          borderRadius: '8px',
          cursor: 'pointer'
        }}
      >
        Start Upload
      </button>
      {/* {isAdmin && (
        <button
          onClick={() => alert("Admin test button clicked")}
          style={{
            padding: '10px 20px',
            fontSize: '1.2rem',
            backgroundColor: '#007BFF',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer'
          }}
        >
          Test (Admin)
        </button>
      )} */}
    </div>
  );
}
